import { HStack } from '@cad-arc';
import { EventPanelFormType, EventPanelOptions } from '@mark43/cad-api';
import { useWatch } from 'react-hook-form';
import { useIntegratedForm } from '../forms/use-integrated-form';
import { propertiesBaseKey } from './constants';
import { useBootstrapState } from '../bootstrap/bootstrap-provider';
import { FrPageBody } from '../fr-page-layout/fr-page-body';
import { FR_FOOTER_HEIGHT, FR_HEADER_HEIGHT } from '../fr-page-layout/constants';
import { FrAddEventPropertyPropertiesWrapper } from './fr-add-event-property-properties-wrapper';
import { EntitiesType } from './types';
import { EventPanelFormPropertyFields } from '../event-panel/event-panel-form/involved-person-vehicle-fields/property/event-panel-form-property-fields';

export function FrAddEventPropertyBody() {
    const { form } = useIntegratedForm<EventPanelFormType>();
    const allPropertiesList = useWatch({ control: form.control, name: propertiesBaseKey })?.flat();
    const { eventPanelOptions } = useBootstrapState();
    const eventOptions = eventPanelOptions ?? ({} as EventPanelOptions);

    return (
        <FrPageBody>
            <HStack
                h={`calc(100vh - ${FR_HEADER_HEIGHT + FR_FOOTER_HEIGHT}px)`}
                w="100%"
                padding={4}
                justifyContent="flex-start"
            >
                <FrAddEventPropertyPropertiesWrapper
                    entitiesType={EntitiesType.FIREARMS}
                    noEntities={!allPropertiesList?.length}
                    allowMembersControl={true}
                    propertyText="Firearms"
                    noMembersText="No Firearms"
                    form={form}
                >
                    <EventPanelFormPropertyFields
                        displayAsCards
                        baseKey="firearms"
                        form={form}
                        eventPanelOptions={eventOptions}
                        hideDexFields={false}
                        addButtonText="Add Firearm"
                        allowMembersControl={true}
                    />
                </FrAddEventPropertyPropertiesWrapper>
                <FrAddEventPropertyPropertiesWrapper
                    entitiesType={EntitiesType.DRUGS}
                    noEntities={!allPropertiesList?.length}
                    form={form}
                    allowMembersControl={true}
                    propertyText="Drugs"
                    noMembersText="No Drugs"
                >
                    <EventPanelFormPropertyFields
                        displayAsCards
                        baseKey="drugs"
                        form={form}
                        eventPanelOptions={eventOptions}
                        hideDexFields={true}
                        addButtonText="Add Drug"
                        allowMembersControl={true}
                    />
                </FrAddEventPropertyPropertiesWrapper>
                <FrAddEventPropertyPropertiesWrapper
                    entitiesType={EntitiesType.OTHER_ITEMS}
                    noEntities={!allPropertiesList?.length}
                    allowMembersControl={true}
                    form={form}
                    propertyText="Other Items"
                    noMembersText="No Other Items"
                >
                    <EventPanelFormPropertyFields
                        displayAsCards
                        baseKey="otherItems"
                        form={form}
                        eventPanelOptions={eventOptions}
                        hideDexFields={false}
                        addButtonText="Add Other Item"
                        allowMembersControl={true}
                    />
                </FrAddEventPropertyPropertiesWrapper>
            </HStack>
        </FrPageBody>
    );
}
